export default __webpack_public_path__ + "static/media/notification.abe90dc1.svg";